import { takeEvery } from 'redux-saga/effects'
import { SeedAction } from './seed.action'
import { seedTransactionsEffect } from './seed.effects'

// Raw takeEvery (not the error-toast wrapper): seed failures are silent — the app
// falls back to lazy fetch, and the effect handles its own errors internally.
function* seedTransactionsSaga() {
  yield takeEvery(SeedAction.SEED_TRANSACTIONS, seedTransactionsEffect)
}

export const SeedWatcher = [seedTransactionsSaga()]
